import { render, staticRenderFns } from "./HouseFundExternalIds.vue?vue&type=template&id=e85f003e&"
import script from "./HouseFundExternalIds.vue?vue&type=script&lang=js&"
export * from "./HouseFundExternalIds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports